<template>
  <div>

      <b-row class="justify-content-center">
        <b-img v-for="ic in icons.filter(x=> x.module.id != null)"
               @click="openTab(ic)" :key="ic.module.id" :src="ic.module.iconPath" :alt="ic.module.title" class="fa-6x icon-size mr-1 mt-1"
               :class="ic.issueDate != null ? null : 'greyscale'"
              v-b-tooltip.hover :title="ic.title"
              />
      </b-row>
  </div>
</template>
``
<script>
const now = new Date();
const today = now.toISOString();

export default {
  mounted() {
    this.$log.debug(this.icons);
  },
  props: {
    icons: Array,
  },
  data() {
    return {
      isVisible: false,
      requirement: {},
      today: today,
      completionDate: today
    }
  },
  methods: {
    openTab(ic) {
      this.$emit('open-tab',ic.module.id);
    }
  }
}
</script>

<style>
  
  .icon-size {
    width: 80px;
    height: 80px;
  }

  .icon-size:hover {
    width: 80px;
    height: 80px;
    cursor: pointer;
  }

  .greyscale {
    filter: grayscale(100%);
  }

</style>